import type { LabelDefinition, LabelSchema } from "../api/types";

const DEFAULT_LABEL: LabelDefinition = {
  name: "",
  description: "",
  color: "#336699",
  kind: "range",
  attributes: {},
};

export function LabelSchemaEditor({ value, onChange }: {
  value: LabelSchema;
  onChange: (value: LabelSchema) => void;
}) {
  const update = (index: number, patch: Partial<LabelDefinition>) => {
    onChange({ labels: value.labels.map((item, position) => position === index ? { ...item, ...patch } : item) });
  };
  const remove = (index: number) => {
    onChange({ labels: value.labels.filter((_, position) => position !== index) });
  };
  const add = () => onChange({ labels: [...value.labels, { ...DEFAULT_LABEL }] });

  return <div className="label-schema-editor">
    {value.labels.map((label, index) => <article className="label-definition-row" key={index}>
      <label className="label-color-field">
        <span>颜色</span>
        <input aria-label={`标签 ${index + 1} 颜色`} type="color" value={label.color || "#336699"} onChange={(event) => update(index, { color: event.target.value.toUpperCase() })} />
      </label>
      <label>
        <span>名称</span>
        <input aria-label={`标签 ${index + 1} 名称`} value={label.name} maxLength={128} required onChange={(event) => update(index, { name: event.target.value })} />
      </label>
      <label>
        <span>类型</span>
        <select aria-label={`标签 ${index + 1} 类型`} value={label.kind || "range"} onChange={(event) => update(index, { kind: event.target.value as LabelDefinition["kind"] })}>
          <option value="point">时间点</option>
          <option value="range">时间区间</option>
        </select>
      </label>
      <label className="label-description-field">
        <span>说明</span>
        <input aria-label={`标签 ${index + 1} 说明`} value={label.description || ""} maxLength={512} placeholder="标注员何时应使用该标签" onChange={(event) => update(index, { description: event.target.value })} />
      </label>
      <button className="icon-button danger-text" type="button" aria-label={`删除标签 ${label.name || index + 1}`} onClick={() => remove(index)}>×</button>
      {Object.keys(label.attributes || {}).length > 0 && <small className="label-attribute-note">保留 {Object.keys(label.attributes || {}).length} 个既有属性</small>}
    </article>)}
    <button className="button ghost compact" type="button" onClick={add}>+ 添加标签</button>
    {!value.labels.length && <p className="inline-warning">至少添加一个标签后，标注员才能在回放中打标。</p>}
  </div>;
}
